import { SyntheticEvent } from 'react'
import Cookies from 'universal-cookie'

import { IGA4EventProps } from './types'

import { isInStorage } from '@/utils/localStorage'
const isProduction = process.env.NODE_ENV === 'production' && process.env.REACT_APP_GA4_ID
const isAnalyticsOff = isInStorage('isImpersonate')

export const sendGA4Event = (props: IGA4EventProps) => {
  const winw = window

  if (isAnalyticsOff) {
    return
  }

  if (isProduction && winw?.gtag) {
    winw.gtag('event', props.action, {
      ...props,
      send_to: process.env.REACT_APP_GA4_ID,
    })
  }
}

export const onSendGA4Event = (props: IGA4EventProps) => {
  return (event?: SyntheticEvent) => {
    event?.stopPropagation()

    sendGA4Event(props)
  }
}

export const getGACookies = (): string[] => {
  const cookies = new Cookies()
  const gaCookies = Object.entries(cookies.getAll())
    .filter(([key]) => key.startsWith('_ga'))
    .map(([, value]) => value as string)

  return gaCookies
}

export const getUTMParams = (): string[] => {
  const urlParams = new URLSearchParams(window.location.search)
  const utmParams: string[] = []

  urlParams.forEach((value, key) => {
    if (key.startsWith('utm_')) {
      utmParams.push(value)
    }
  })

  return utmParams
}

export const hasGLParam = (): boolean => {
  const urlParams = new URLSearchParams(window.location.search)
  let found = false

  urlParams.forEach((_, key) => {
    if (key.includes('_gl')) {
      found = true
    }
  })

  return found
}
